import styled from 'styled-components'

import FormikForm from '../../../form/FormikForm'
import FormSubmitButton from '../../../form/FormSubmitButton'
import FormErrors from '../../../form/FormErrors'
import Card from '../../../Card'
import breakpoints from '../../../../theme/breakpoints'
import FormFieldInput from '../../../form/fields/FormFieldInput'
import ActionButton from '../../../ActionButton'
import CHtml from '../../../../components/Html'

export const CardWrapper = styled(Card)``

export const Title = styled.h6`
  ${({ theme }) => theme.textStyles.H6};
  margin-bottom: 1.6rem;
  text-align: center;
  color: ${({ theme }) => theme.colors.nightRider};
`

export const Html = styled(CHtml)`
  ${({ theme }) => theme.textStyles.textMedium};
  color: ${({ theme }) => theme.colors.nightRider};
  line-height: 1.6;
  text-align: center;
  margin-bottom: 3.2rem;
  max-width: 60rem;
`

export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
  align-items: center;
`

export const FieldText = styled(FormFieldInput)`
  width: 100%;
  min-width: 25rem;

  ${breakpoints.up('tablet')} {
    min-width: 37rem;
  }
`

export const Errors = styled(FormErrors)``

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2.4rem;
  margin-top: 3.2rem;
`

export const NotReceivedCodeButton = styled(ActionButton)``

export const SubmitButton = styled(FormSubmitButton)`
  width: max-content;
`
